import { useCallback, useContext, useEffect, useState } from "react";
import styles from "./MySubscription.module.css";
import { LanguageContext } from "../../../context/LanguageContext";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Loader from "../../../components/spinner/Loader";
import getMySubscriptionData from '../../../store/subscriptions/mySubscription/MySubscription';
import { PLAN_DESCRIPTIONS, PLAN_TYPES } from "../../../utils/helpers/subscriptions/plans";
import BenefitsCard from "../../../components/subscriptions/benefitsCard/BenefitsCard";
import MembersCard from "../../../components/subscriptions/familyMebers/MembersCard";
import GamesPromo from "../../../components/subscriptions/gamePromo/GamesPromo";
import getFamilyMembers from "../../../store/family/getFamilyMembers/GetFamilyMembers";
import SubscriptionPlans from "../subscriptionPlans/SubscriptionPlans";
import BillingHistory from "../../../components/subscriptions/billingHistory/BillingHistory";
import ConfirmationModal from "../../../components/modal/confirmationModal/ConfirmationModal";
import leaveFamily from "../../../store/family/leaveFamily/LeaveFamily";
import { leaveFamilyAction } from "../../../store/family/leaveFamily/LeaveFamilySlice";
import { useCurrentUser } from "../../../hooks/useCurrentUser";
import toast from "react-hot-toast";

export default function MySubscription() {
  const { data, language: lang } = useContext(LanguageContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { refetchUser } = useCurrentUser();
  const mySubscriptionData = useSelector((state) => state.mySubscription);
  const getFamilyMembersData = useSelector((state) => state.getFamilyMembers);
  const leaveFamilyData = useSelector((state) => state.leaveFamily);
  
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const token = Cookies.get("auth_token");
  const t = useCallback((key) => data?.[key]?.[lang], [data, lang]);  

  useEffect(() => {
    if (token) {
      dispatch(getMySubscriptionData(token));
      dispatch(getFamilyMembers(token))
    }
  }, [dispatch, token]);

  useEffect(() => {
    if (leaveFamilyData?.status === "succeeded") {
      setLoading(false)
      setShowModal(false)
      dispatch(getMySubscriptionData(token));
      refetchUser();
      dispatch(leaveFamilyAction.leaveFamilyReset());
    } else if (leaveFamilyData?.status === "failed") {
      setLoading(false)
      toast.remove()
      toast.error(t(leaveFamilyData?.error?.Error) ?? t("something_went_wrong"));
      dispatch(leaveFamilyAction.leaveFamilyReset());
    }
  }, [dispatch, leaveFamilyData, token, refetchUser, t])

  function confrimLeaveFamily() {
    if (token) {
      setLoading(true)
      dispatch(leaveFamily(token));
    }
  }

  const subscription = mySubscriptionData?.mySubscription;
  const entitlements = subscription?.entitlements;

  const getOwnerContact = (owner) => owner?.phoneNumber || owner?.email || owner?.username || "-";
  const showMembers = subscription?.plan === PLAN_TYPES.FAMILY && subscription?.isFamilyOwner;

  if (!entitlements || Object.keys(entitlements).length === 0 || !getFamilyMembersData) return <Loader />;

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <button className={styles.backBtn} onClick={() => navigate(-1)}>
          <img src="/assets/subscriptions/back.svg" alt="" width={20} height={20}/>
        </button>
        <span className={styles.title}>{t("my_subscription")}</span>
      </header>

      <div className={`${styles.grid} ${!showMembers ? styles.singleColumn : ""}`}>
        <div className={styles.left} style={{ width: "100%" }}>
          <div className={styles.planCard}>
            <span className={styles.planBadge}>{t("current_subscription")}</span>
            <h2 className={styles.planName}>{subscription?.plan === PLAN_TYPES.FAMILY ? t('vinni_plus_family') : t(subscription?.plan?.toLowerCase())}</h2>
            <p className={styles.planTagline}>{t(PLAN_DESCRIPTIONS[subscription?.plan])}</p>
            {subscription?.plan === PLAN_TYPES.FAMILY && !subscription?.isFamilyOwner && (
              <div className={styles.invitedBy}>
                <span className={styles.invitedByText}>
                  {t("invited_by")} <strong>{getOwnerContact(getFamilyMembersData.data?.owner)}</strong>
                </span>
                <div className={styles.leaveBtn} onClick={() => setShowModal(true)}>
                  <span>{t('leave_the_family')}</span>
                </div>
              </div>
            )}
          </div>
          <BenefitsCard entitlements={entitlements} t={t} plan={subscription?.plan} lang={lang}/>
        </div>

        <div className={styles.right}>
          {showMembers && (
            <MembersCard t={t} subscription={subscription}/>
          )}
        </div>
      </div>
      <SubscriptionPlans type="mySubscription"/>
      <BillingHistory lang={lang} t={t} userPlan={subscription?.plan}/>
      <GamesPromo t={t}/>
      {showModal && (
        <ConfirmationModal
          show={showModal}
          onHide={() => setShowModal(null)}
          logOutHandler={confrimLeaveFamily}
          titles={{
            max_title: loading ? <Loader className={styles.customLoaderHeight}/> : `${t("leave_family_title")}`,
            mid_title: loading ? "" : t('leave_family_subtitle')
          }}
          loading={loading}
        />
      )}
    </div>
  );
};